module.exports = __webpack_public_path__ + "static/media/refresh.904a7e61.svg";